// @ts-nocheck
import React from 'react'
import cx from 'classnames'

import styles from './ListItem.module.scss'

export const ListItem = React.forwardRef(
  ({ children, className = undefined }, ref) => (
    <li
      className={cx(styles.item, { [className]: Boolean(className) })}
      {...{ ref }}
    >
      {children}
    </li>
  ),
)
